<script>
import PendingProgressView from "@/pages/visitJobs/comp/PendingProgressView.vue";
import PendingTransferInfoView from "@/pages/visitJobs/comp/PendingTransferInfoView.vue";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {mixin_visitor_setting} from "@/utils/mixin";
import {getVisitorByBatch} from "@/api/visitor-api";
import {getApproves, getMakeCopies, getTransfers} from "@/api/apply-api";
import {getEmployeeByBatch} from "@/api/organize-api";
import {getVisitorRecord} from "@/api/record-api";

export default {
  name: "ApplyShowDetailDrawer",
  components: {PendingTransferInfoView, PendingProgressView},
  mixins: [mixin_visitor_setting],
  props: {
    drawerTitle: String,
    areaMap: Object,
    phoneNumShow: Boolean,
  },
  data() {
    return {
      drawerShow: false,
      drawForm: [],
      employee: {},
      visitor: {},
      applyDetail: {
        approveDataGet: false,
        copyData: [],
        approveData: [],
        transferData: [],
        visitorData: [],
      },
      noteList: []
    }
  },

  methods: {

    async showApplyDetail(apply) {
      console.log("showApplyDetail", apply);
      await this.setupVisitorSetting(apply.type)
      this._tableShow(apply)
    },

    _tableShow(apply) {
      console.log("tableShow data", apply);
      this.drawData = apply
      let employeeTel = apply.employee ? apply.employee.tel : ""
      let visitorTel = apply.visitor.tel
      if (!this.phoneNumShow) {
        if (employeeTel) {
          employeeTel = employeeTel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
        visitorTel = apply.visitor.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      let employeeHead = require('@/assets/default_header.webp')
      if (apply.employee && apply.employee.head) {
        employeeHead = getFileUrl(apply.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (apply.visitor.head) {
        visitorHead = getFileUrl(apply.visitor.head)
      }
      this.employee = {
        headUrl: employeeHead,
        name: apply.employee ? apply.employee.name : "",
        tel: employeeTel,
        workId: apply.employee ? apply.employee.workId : "",
      }
      this.visitor = {
        headUrl: visitorHead,
        name: apply.visitor.name,
        tel: visitorTel,
        company: apply.visitor.company,
      }

      this.noteList = []
      if (apply.arrived !== "NO") {
        const visitorId = apply.visitor.id
        const applyId = apply.id
        this.getNoteMsg(visitorId, applyId)
      } else {
        this.noteList.push({info: "未到访", timeCome: "", timeLeave: ""})
      }

      let startTime = `${apply.beginDate} ${apply.beginTime.substr(0, 5)}`
      let endTime = `${apply.endDate} ${apply.endTime.substr(0, 5)}`
      this.drawForm = []
      let subArea, superArea
      subArea = apply.entryArea ? this.areaMap[apply.entryArea] : null
      superArea = subArea ? this.areaMap[subArea.parentId] : null
      this.drawForm.push({title: "到访父区域", value: superArea ? superArea.name : ""})
      this.drawForm.push({title: "到访子区域", value: subArea ? subArea.name : ""})
      this.drawForm.push({title: "开始时间", value: startTime})
      this.drawForm.push({title: "结束时间", value: endTime})
      if (apply.forms) {
        apply.forms.forEach(item => {
          if (item.type === "beginTime" || item.type === "endTime" || item.type === "accompany") {
            return
          }
          this.drawForm.push(item)
        })
      }
      this.requestApplyDetailInfo(apply)
      this.drawerShow = true
    },
    // 通讯录中不存在的审批人 code（MAIL=邮件审批人，被访员工不在通讯录场景）显示友好名
    unknownApproverName(code) {
      if (code === "MAIL") {
        return "邮件审批";
      }
      return code || "未知";
    },

    requestApplyDetailInfo(applyInfo) {
      this.applyDetail = {visitorData: [], copyData: [], approveData: [], transferData: [], approveDataGet: false}
      if (applyInfo.visitorCardNo) {
        this.$set(applyInfo.visitor, 'preCardNo', applyInfo.visitorCardNo)
      }
      this.applyDetail.visitorData.push(applyInfo.visitor)
      // 同行人
      if (applyInfo.accompanies) {
        let codes = applyInfo.accompanies.split('|')
        getVisitorByBatch(codes).then(({data}) => {
          if ((data.code === 200) && (data.data != null)) {
            let accompanyCards = applyInfo.accompanyCards ? applyInfo.accompanyCards : {}
            data.data.forEach(item => {
              item.preCardNo = accompanyCards[item.code]
            })
            this.applyDetail.visitorData.push(...data.data)
          }
        }).catch(err => {
          console.log("getVisitorByBatch net err ", err)
        })
      }
      // 抄送人
      getMakeCopies(applyInfo.id).then(({data}) => {
        if ((data.code === 200) && (data.data != null)) {
          let copyData = data.data
          let copyEmployeeCodes = data.data.map(item => item.employeeCode)
          getEmployeeByBatch(copyEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              let copyEmployeeList = data.data
              copyData.forEach(item => {
                let employee = copyEmployeeList.find(employee => employee.code === item.employeeCode)
                item.employeeName = employee ? employee.name : this.unknownApproverName(item.employeeCode)
              })
              this.applyDetail.copyData.push(...copyData)
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch(err => {
        console.log("getMakeCopies net err ", err)
      })
      // 审批人
      getApproves(applyInfo.id).then(({data}) => {
        console.log("getApproves => ", data)
        this.applyDetail.approveDataGet = true
        if ((data.code === 200) && (data.data != null)) {
          let approveData = data.data
          let approveEmployeeCodes = data.data.map(item => item.employeeCode)
          getEmployeeByBatch(approveEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              let approveEmployeeList = data.data
              approveData.forEach(item => {
                let employee = approveEmployeeList.find(employee => employee.code === item.employeeCode)
                item.employeeName = employee ? employee.name : this.unknownApproverName(item.employeeCode)
              })
              this.applyDetail.approveData = [...approveData]
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch(err => {
        console.log("getApproves net err ", err)
      })

      getTransfers(applyInfo.id).then(({data}) => {
        if (data.code === 200 && data.data != null) {
          console.log("getTransfers", data.data)
          let transferInfo = data.data
          let transferEmployeeCodes = []
          transferInfo.forEach(item => {
            if (item.fromEmployeeCode && !transferEmployeeCodes.includes(item.fromEmployeeCode)) {
              transferEmployeeCodes.push(item.fromEmployeeCode)
            }
            if (item.toEmployeeCode && !transferEmployeeCodes.includes(item.toEmployeeCode)) {
              transferEmployeeCodes.push(item.toEmployeeCode)
            }
          })
          getEmployeeByBatch(transferEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch for getTransfers", data.data)
            if (data.code === 200 && data.data != null) {
              let employeeList = data.data
              transferInfo.forEach(item => {
                if (item.fromEmployeeCode) {
                  let employee = employeeList.find(emp => emp.code === item.fromEmployeeCode)
                  item.fromEmployeeName = employee ? employee.name : ""
                } else {
                  item.fromEmployeeName = ''
                }
                if (item.toEmployeeCode) {
                  let employee = employeeList.find(emp => emp.code === item.toEmployeeCode)
                  item.toEmployeeName = employee ? employee.name : ""
                } else {
                  item.toEmployeeName = ''
                }
              })
              this.applyDetail.transferData = [...transferInfo]
            }
          }).catch(err => {
            console.log("getEmployeeByBatch err " + err)
          })
        }
      })
    },
    getNoteMsg(visitorId, applyId) {
      getVisitorRecord(visitorId, applyId).then(({data}) => {
        console.log("getVisitorRecord", data);
        if (data.code !== 200) {
          this.showServerErrMsg(data.msg)
          return
        }
        if (data.data == null || data.data.length === 0) {
          return
        }
        data.data.forEach(item => {
          let info = "", timeCome = "", timeLeave = "", enterPhotoUrl = ""
          if (item.completeState) {
            info = this.$options.filters.tableDateFilter(item.completeState, 'param13')
          }
          if (item.enterDate && item.enterTime) {
            timeCome = `${item.enterDate} ${item.enterTime.substr(0, 5)}`
          }
          if (item.leaveDate && item.leaveTime) {
            timeLeave = `${item.leaveDate} ${item.leaveTime.substr(0, 5)}`
          }
          if (item.enterPhoto) {
            enterPhotoUrl = getFileUrl(item.enterPhoto,)
          }
          this.noteList.push({info, timeCome, timeLeave, enterPhotoUrl})
        })
      }).catch((err) => {
        console.log("getVisitorRecord err", err);
      })
    },

  }, // methods

  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
    phoneNoFilter(value) {
      // return value + 121
      return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    icCardNoFilter(value) {
      return value.replace(/(\d{5})\d{10}(\d{3})/, '$1****$2')
    }
  }


}
</script>

<template>
  <div>
    <el-drawer class="drawer-content" :visible.sync="drawerShow" :with-header="false" direction="rtl" :size="tableWidth">
      <div class="flex justify-between items-center h-16 p-5">
        <div class="font-bold">{{drawerTitle}}</div>
        <button @click="drawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="h-0.5 w-full bg-gray-300"></div>
      <el-row>
        <el-col :span="12">
          <div class="grid-content">
            <h4>员工信息</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="employee.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="employee.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="employee.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">工号：</span>
              <el-input size="mini"
                        v-model="employee.workId" :disabled="true" class="input-short"></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content">
            <h4>访客信息</h4>
            <div class="input-item-box"><span class="input-description">头像：</span>
              <el-image class="image-header" :src="visitor.headUrl" fit="cover">
              </el-image>
            </div>
            <div class="input-item-box"><span class="input-description">姓名：</span>
              <el-input size="mini"
                        v-model="visitor.name" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">手机：</span>
              <el-input size="mini"
                        v-model="visitor.tel" :disabled="true" class="input-short"></el-input>
            </div>
            <div class="input-item-box"><span class="input-description">公司：</span>
              <el-input size="mini"
                        v-model="visitor.company" :disabled="true" class="input-short"></el-input>
            </div>
          </div>

        </el-col>
      </el-row>
      <div class="grid-content">
        <h4>表单信息</h4>
        <div v-for="(item, index) in drawForm" :key="index" class="input-item-box">
          <span class="input-description-long">{{ item.title }}:</span>
          <el-input size="mini" :placeholder="item.value" :disabled="true" class="input-long"></el-input>
        </div>
      </div>
      <div class="grid-content ">
        <h4>全部访客</h4>
        <el-table :data="applyDetail.visitorData" border stripe size="mini">
          <el-table-column prop="name" label="访客姓名" width="70"></el-table-column>
          <el-table-column prop="tel" label="访客手机" width="100">
            <template slot-scope="scope">
                <div v-if="phoneNumShow">{{scope.row.tel}}</div>
                <div v-else>{{scope.row.tel | phoneNoFilter}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="preCardNo" label="访客卡号" width="70"></el-table-column>
          <el-table-column prop="ic" label="身份证号" v-if="visitorShowSetting.showIC" width="150">
            <template slot-scope="scope">
              <div v-if="phoneNumShow">{{scope.row.ic}}</div>
              <div v-else>{{scope.row.ic | icCardNoFilter}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="nationality" label="访客国籍" v-if="visitorShowSetting.showNationality" width="120"></el-table-column>
          <el-table-column prop="tag" label="访客护照" v-if="visitorShowSetting.showPassport" width="90"></el-table-column>
          <el-table-column prop="email" label="访客邮箱" v-if="visitorShowSetting.showEmail"></el-table-column>
          <el-table-column prop="company" label="访客公司"></el-table-column>
        </el-table>
      </div>
      <div class="grid-content" v-if="applyDetail.copyData.length > 0">
        <h4>抄送人列表</h4>
        <div v-for="item in applyDetail.copyData" :key="item.id" class="input-item-box">
          <span class="input-description-long">抄送人:</span>
          <el-input size="mini" :placeholder="item.employeeName" :disabled="true" class="input-long"></el-input>
        </div>
      </div>
      <div class="grid-content" v-if="applyDetail.approveDataGet">
        <PendingProgressView :pendingProgressData="applyDetail.approveData"
                             :applyData="drawData" :showTitle="false"></PendingProgressView>
      </div>

      <div class="grid-content" v-if="applyDetail.transferData.length > 0">

        <PendingTransferInfoView
            :transferInfoData="applyDetail.transferData" :showTitle="false"></PendingTransferInfoView>
      </div>
      <div class="grid-content">
        <h4>记录信息</h4>
        <template v-for="(item, index) in noteList">
          <div class="input-item-box" :key="item.info + 1 + index"><span class="input-description-long">到访情况:</span>
            <el-input size="mini"
                      v-model="item.info" :disabled="true" class="input-long"></el-input>
          </div>
          <div class="input-item-box" :key="item.info  + 2 + index"><span
              class="input-description-long">到访时间:</span>
            <el-input size="mini"
                      v-model="item.timeCome" :disabled="true" class="input-long"></el-input>
          </div>
          <div style="margin-bottom: 20px" class="input-item-box" :key="item.info  + 3 + index"><span
              class="input-description-long">离开时间:</span>
            <el-input size="mini"
                      v-model="item.timeLeave" :disabled="true" class="input-long"></el-input>
          </div>
          <div style="margin-bottom: 20px" class="input-item-box" :key="item.info  +  + index"><span
              class="input-description-long">签到图片:</span>
            <el-image class="image-photo" :src="item.enterPhotoUrl" fit="cover">
              <div slot="error" class="image-photo">
                <span v-if="item.enterPhotoUrl">加载失败</span>
                <span v-else>没有拍照</span>
              </div>
            </el-image>
          </div>

        </template>
      </div>
    </el-drawer>
  </div>
</template>

<style lang="less" scoped>

.drawer-content {

  .drawer-title {
    margin-left: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 380px;
  }

  .grid-content {
    //padding: 20px;

    margin: 8px 8px 8px 20px;
  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
    //text-align: right;
    //margin-right: 8px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}

.image-photo {
  width: 360px;
  height: 270px;
  background-color: #efefef;
  line-height: 270px;
  text-align: center;
}

.el-input {
  width: calc(100% - 50px);
}


/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
</style>

